//utilities import
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import APIURL from "../APIURL";
import useSWR from "swr";
import axios from "axios";
import { Prompt } from "react-router-dom";
import moment from "moment";

//kendo elements
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { SvgIcon } from "@progress/kendo-react-common";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Fade } from "@progress/kendo-react-animation";
import {
  Notification,
  NotificationGroup,
} from "@progress/kendo-react-notification";
import { pencilIcon, trashIcon, downloadIcon } from "@progress/kendo-svg-icons";
import {
  Grid as GridTelerik,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { Card, CardHeader } from "@progress/kendo-react-layout";
import { useLocalization } from "@progress/kendo-react-intl";
import {
  RequiredFormDatePicker,
  RequiredDropDownList,
  RequiredFormInput,
  RequiredFormTextArea,
} from "../common/Kendo/form-components";
import {
  BirthDateValidator,
  requiredMax50Validator,
  requiredValidator,
} from "../common/Kendo/validators";
//component
import ApproveStudySubject from "../studysubject/ApproveStudySubject";
import Genders from "../common/commoncomponents/Genders";
import AddFile from "../common/commoncomponents/AddFile";
import PermissionDenied from "../common/commoncomponents/PermissionDenied";
import DeleteObject from "../common/commoncomponents/DeleteObject";
import AddNote from "../common/commoncomponents/AddNote";
import GlobalNotificationTimer from "../common/commoncomponents/GlobalNotificationTimer";
import Nationalities from "../common/commoncomponents/Nationalities";
import Countries from "../common/commoncomponents/Countries";
import TabChange from "../common/commoncomponents/TabChange";
import TrialMap from "../studysubject/TrialMap";
export function AddDemography(props) {
  //redux
  const UserDetail = useSelector((state) => state.UserDetail);
  const EditSubject = useSelector((state) => state.EditSubject);

  const [approvedformchanged, setapprovedformchanged] = useState(false);

  //localization
  const localizationService = useLocalization();

  //notes data
  const fetcher2 = (url) =>
    axios
      .get(url, {
        params: {
          subject: props.location.state.data.id,
          section: props.location.state.section.id,
        },
      })
      .then((res) => res.data);

  const { data: checkapprove, checkapproveerror } = useSWR(
    props.location.state
      ? [
          APIURL + `/common/checkapprove/`,
          props.location.state.data.id,
          props.location.state.section.id,
        ]
      : null,
    fetcher2
  );
console.log("JJJJJJJJJJJJJJJJJ11",checkapprove,checkapproveerror)
  const { data: notes, Noteserror } = useSWR(
    props.location.state
      ? [
          APIURL + "/common/listnote/",
          props.location.state.data.id,
          props.location.state.section.id,
        ]
      : null,
    fetcher2
  );

  //attachements data
  const fetcher4 = (url) =>
    axios
      .get(url, {
        params: {
          subject: props.location.state.data.id,
          section: props.location.state.section.id,
        },
      })
      .then((res) => res.data);

  const { data: attachements, Attchementserror } = useSWR(
    props.location.state
      ? [
          APIURL + "/common/listfile/",
          props.location.state.data.id,
          props.location.state.section.id,
        ]
      : null,
    fetcher4
  );

  //date template
  const DateCreatedTemplate = (dataItem) => {
    return (
      <td>
        {moment(dataItem.dataItem.date_created).format("YYYY-MM-DD HH:mm")}
      </td>
    );
  };

  //FILE RELATED ACTIONS
  const Fileactions = (dataItem) => {
    return (
      <td>
        <div className="row">
          <div className="col-6">
            <SvgIcon
              svgStyle={{ cursor: "pointer", color: "grey" }}
              icon={downloadIcon}
              onClick={() => {
                EditSubject
                  ? DownloadFile(
                      dataItem.dataItem.id,
                      dataItem.dataItem.attachement_name,
                      dataItem.dataItem.title
                    )
                  : toggleDPermission();
              }}
            />
          </div>
          <div className="col-6">
            <SvgIcon
              svgStyle={{ cursor: "pointer", color: "red" }}
              icon={trashIcon}
              onClick={() => {
                setDeleteAPI(`/common/updatefile/${dataItem.dataItem.id}/`);
                setName(dataItem.dataItem.title);
                EditSubject ? toggleDdelete() : toggleDPermission();
              }}
            />
          </div>
        </div>
      </td>
    );
  };

  const DownloadFile = (id, title) => {
    axios
      .get(APIURL + `/common/downloadfile/${id}/`, {
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", title);
        document.body.appendChild(link);
        link.click();
      });
  };

  //Permission dialog
  const [VPermission, setVPermission] = useState(false);

  const toggleDPermission = () => {
    setVPermission(!VPermission);
  };

  //Dialog for tabstrip change
  const [selectedTab, setSelectedTab] = useState(null);
  const [VTabStripChange, setVTabStripChange] = useState(false);

  const toggleDTabStripChange = () => {
    setVTabStripChange(!VTabStripChange);
  };

  //callback function to send state from child to parent
  const TabCallBack = (value) => {
    setSelected(value);
    setapprovedformchanged(false);
  };

  //dialog for deleting object
  const [DeleteAPI, setDeleteAPI] = useState("");
  const [Name, setName] = useState("");
  const [Vdelete, setVdelete] = useState(false);

  const toggleDdelete = () => {
    setVdelete(!Vdelete);
  };

  //dialog for adding and updating files :
  const [VaddFile, setVaddFile] = useState(false);

  const toggleDaddFile = () => {
    setVaddFile(!VaddFile);
  };

  //dialog for adding and updating and deleting notes
  const [VaddNote, setVaddNote] = useState(false);

  const toggleDaddNote = () => {
    setVaddNote(!VaddNote);
  };
  const [VeditNote, setVeditNote] = useState(false);

  const toggleDeditNote = () => {
    setVeditNote(!VeditNote);
  };

  //tooltip
  const TooltipContentTemplate = (props) => {
    return (
      <div className="custom-tooltip">
        <strong>{props.title}</strong>
      </div>
    );
  };

  //NoteNameTemplate
  const NoteNameTemplate = (dataItem) => {
    return dataItem.dataItem.note.length > 20 ? (
      <td style={{ cursor: "pointer" }}>
        <Tooltip
          openDelay={0}
          tooltipStyle={{
            width: "200px",
            textAlign: "center",
          }}
          content={(props) => <TooltipContentTemplate title={props.title} />}
          anchorElement="target"
          position="top"
          parentTitle={true}
        >
          <div title={dataItem.dataItem.note}>
            {dataItem.dataItem.note.slice(0, 20)}
            {"..."}
          </div>
        </Tooltip>
      </td>
    ) : (
      <td>
        {" "}
        <div>{dataItem.dataItem.note}</div>
      </td>
    );
  };

  //NOTE ACTIONS
  const Noteactions = (dataItem) => {
    return (
      <td>
        <div className="row">
          <div className="col-6">
            <SvgIcon
              className="EditActionButtons"
              icon={pencilIcon}
              onClick={() => {
                setEditNote(dataItem.dataItem);
                EditSubject ? toggleDeditNote() : toggleDPermission();
              }}
            />
          </div>
          <div className="col-6">
            <SvgIcon
              className="DeleteActionButtons"
              icon={trashIcon}
              onClick={() => {
                setDeleteAPI(`/common/updatenote/${dataItem.dataItem.id}/`);
                setName(dataItem.dataItem.note);
                EditSubject ? toggleDdelete() : toggleDPermission();
              }}
            />
          </div>
        </div>
      </td>
    );
  };

  //Modification Reason Dialog
  const [VModifyreason, setVModifyreason] = useState(false);

  const toggleDModifyreason = () => {
    setVModifyreason(!VModifyreason);
  };

  //data

  const { data, error } = useSWR(
    props.location.state
      ? APIURL + `/common/detailsubject/${props.location.state.data.id}/`
      : null
  );

  //date of 18 years and above for date picker limits
  const now = new Date();

  const min = new Date(now.getFullYear() - 1);

  // Notification
  const [ErrorNotification, setErrorNotification] = useState("");
  const position = {
    topCenter: {
      top: 0,
      left: "50%",
      transform: "translateX(-50%)",
    },
  };

  const [state, setState] = React.useState({
    success: false,
    nosave: false,
    deleted: false,
    nomodify: false,
  });

  const onToggle = (flag) => setState({ ...state, [flag]: !state[flag] });

  const { success, nosave, deleted, nomodify } = state;

  //variables
  const [loading, setLoading] = useState(false);
  const [approved, setApproved] = useState(false);
  const MyForm = React.createRef(); //form ref to detect modification of the form
  const [EditNote, setEditNote] = useState([]); //to transfer data  edit note
  const [AllData, setAllData] = useState([]);
  const [ModifiedData, setModifiedData] = useState();

  useEffect(() => {
    if (data) {
      if (data.SubjectDemography) {
        setAllData(data.SubjectDemography);
      } else {
        setAllData({});
      }
    }

    if (checkapprove) {
      setApproved(checkapprove);
    }
  }, [data, checkapprove]);

  //goback function

  const goBack = (event) => {
    if (event.type === "click") {
      props.history.push("/crf/studysubject/list");
    }
  };
  const [test, settest] = useState();

  const CreateDemography = (dataItem) => {
    if (dataItem.isValid) {
      if (Object.keys(AllData).length !== 0) {
        if (dataItem.isModified) {
          setModifiedData(dataItem.values);
          toggleDModifyreason();
        } else {
          onToggle("nomodify");
          setLoading(false);
          setTimeout(() => {
            setState({ ...state, nomodify: false });
          }, GlobalNotificationTimer);
        }
      } else {
        setLoading(true);
        axios
          .post(APIURL + "/opera/screening/adddemography/", {
            created_by: UserDetail.id,
            modified_by: null,
            study_subject: props.location.state.data.id,
            section: props.location.state.section.id,
            modification_log: [],
            birthdate: moment(dataItem.values.birthdate).format("YYYY-MM-DD"),
            gender: dataItem.values.gender.value,
            country: [dataItem.values.country],
            nationality: dataItem.values.nationality.value,
            other_nationality: dataItem.values.other_nationality,
          })
          .then((res) => {
            onToggle("success");
            setTimeout(() => {
              setState({ ...state, success: false });
              setLoading(false);
            }, GlobalNotificationTimer);
          })
          .catch((error) => {
            setErrorNotification(error.response.status);
            onToggle("nosave");
            setTimeout(() => {
              setState({ ...state, nosave: false });
              setLoading(false);
            }, GlobalNotificationTimer);
          });
      }
    }
  };

  //TAB STRIP
  const [selected, setSelected] = React.useState(0);
  const handleSelect = (e) => {
    if (selected === 1) {
      if (approvedformchanged === true) {
        setSelectedTab(e.selected);
        toggleDTabStripChange();
      } else {
        setSelected(e.selected);
      }
    } else if (
      MyForm.current &&
      Object.keys(MyForm.current.modified).length !== 0
    ) {
      setSelectedTab(e.selected);
      toggleDTabStripChange();
    } else {
      setSelected(e.selected);
    }
  };

  const [Subselected, setSubSelected] = React.useState(0);

  const handleSubSelect = (e) => {
    setSubSelected(e.selected);
  };

  //prompt function to trigger any change
  const PromptFunction = (formRenderProps) => {
    let boolean = false;
    if (formRenderProps.modified) {
      boolean = true;
    } else {
      boolean = false;
    }

    return boolean;
  };
  const disableFunction = () => {
    let boolean = false;
    if (!EditSubject || approved || loading) {
      boolean = true;
    }
    return boolean;
  };

  const disabletitle = () => {
    let title = "";
    if (!EditSubject && approved) {
      title = localizationService.toLanguageString("custom.nopermissiontoedit");
    }
    if (!EditSubject) {
      title = localizationService.toLanguageString("custom.nopermissiontoedit");
    } else if (approved) {
      title = localizationService.toLanguageString(
        "custom.thesectionhasbeenapproved"
      );
    } else {
      title = localizationService.toLanguageString("custom.savechanges");
    }
    return title;
  };
  const OnNationalityChange = (e, formRenderProps) => {
    formRenderProps.onChange("other_nationality", { value: "" });
  };

  const CreateModification = (dataItem) => {
    toggleDModifyreason(false);
    setLoading(true);
    axios
      .put(APIURL + "/opera/screening/updatedemography/" + AllData.id + "/", {
        created_by: AllData.created_by,
        modified_by: UserDetail.id,
        study_subject: props.location.state.data.id,
        section: props.location.state.section.id,
        birthdate: moment(ModifiedData.birthdate).format("YYYY-MM-DD"),
        gender: ModifiedData.gender.value,
        country: [ModifiedData.country],
        nationality: ModifiedData.nationality.value,
        other_nationality: ModifiedData.other_nationality,
        modification_reason: dataItem.modification_reason,
      })
      .then((res) => {
        onToggle("success");
        setTimeout(() => {
          setState({ ...state, success: false });
          setLoading(false);
        }, GlobalNotificationTimer);
      })
      .catch((error) => {
        setErrorNotification(error.response.status);
        onToggle("nosave");
        setTimeout(() => {
          setState({ ...state, nosave: false });
          setLoading(false);
        }, GlobalNotificationTimer);
      });
  };

  const ChangeApproveSection = (value) => {
    setapprovedformchanged(value);
  };
  //SWR ESSENTIAL
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">
        {localizationService.toLanguageString("custom.loading")}
      </span>
      <div className="k-loading-image"></div>
      <div className="k-loading-color"></div>
    </div>
  );

  if (error && Noteserror && Attchementserror && checkapproveerror)
    return <>{localizationService.toLanguageString("custom.failedload")}</>;

  return (
    <TrialMap>
      {(!data || !notes || !attachements) && loadingPanel}
      <div className="row">
        <div className="col-12">
          <Card>
            <CardHeader className="DetailFormHeader">
              <div className="row">
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.subjectid")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString(
                    "custom.subjectinitials"
                  )}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.study")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.protocolid")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.sitenumber")}
                </div>
                <div className="col DetailCardElementTitle">
                  {localizationService.toLanguageString("custom.createdby")}
                </div>
              </div>
              <div className="row">
                <div className="col text-responsive-overflow subject-id-style">
                  {props.location.state ? props.location.state.data.crf_id : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.subject_initial
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.study_name
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.study_protocol
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.subject_center
                    : ""}
                </div>
                <div className="col text-responsive-overflow">
                  {props.location.state
                    ? props.location.state.data.createdBy
                    : ""}
                </div>
              </div>
              <hr className="RowRoleHr" />
              <div className="row">
                <div className="col pages-big-title">
                  <strong>
                    {localizationService.toLanguageString("custom.demography")}
                  </strong>
                </div>
                <div className="col">
                  <div className="float-right">
                    <Button onClick={goBack} className="back-button-style">
                      {localizationService.toLanguageString("custom.back")}
                    </Button>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-12">
          <TabStrip selected={selected} onSelect={handleSelect}>
            <TabStripTab
              title={localizationService.toLanguageString("custom.demography")}
            >
              <Form
                initialValues={{
                  birthdate:
                    Object.keys(AllData).length !== 0
                      ? new Date(AllData.birthdate)
                      : null,
                  country:
                    Object.keys(AllData).length !== 0
                      ? AllData.country[0]
                      : null,
                  nationality:
                    Object.keys(AllData).length !== 0
                      ? {
                          name: AllData.nationality,
                          value: AllData.nationality,
                        }
                      : null,
                  other_nationality:
                    Object.keys(AllData).length !== 0
                      ? AllData.other_nationality
                      : "",
                  gender:
                    Object.keys(AllData).length !== 0
                      ? { name: AllData.gender, value: AllData.gender }
                      : null,
                }}
                ref={MyForm}
                onSubmitClick={CreateDemography}
                key={JSON.stringify(AllData)}
                render={(formRenderProps) => (
                  <FormElement className="">
                    <fieldset className={"k-form-fieldset"}>
                      <Tooltip
                        openDelay={0}
                        anchorElement="target"
                        parentTitle={true}
                        position={"top"}
                      >
                        <Prompt
                          when={PromptFunction(formRenderProps)}
                          message={localizationService.toLanguageString(
                            "custom.promptmessage"
                          )}
                        />
                        <div className="col-6">
                          <div className="row">
                            <div className="col-6">
                              <Field
                                id={"birthdate"}
                                name={"birthdate"}
                                label={localizationService.toLanguageString(
                                  "custom.birthdate"
                                )}
                                validator={BirthDateValidator}
                                component={RequiredFormDatePicker}
                              />
                            </div>
                            <div className="col-6">
                              {" "}
                              <Field
                                id={"country"}
                                name={"country"}
                                label={localizationService.toLanguageString(
                                  "custom.country"
                                )}
                                component={RequiredDropDownList}
                                data={Countries}
                                validator={requiredValidator}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <Field
                                id={"nationality"}
                                name={"nationality"}
                                label={localizationService.toLanguageString(
                                  "custom.nationality"
                                )}
                                component={RequiredDropDownList}
                                data={Nationalities}
                                onChange={(e) =>
                                  OnNationalityChange(e, formRenderProps)
                                }
                                validator={requiredValidator}
                              />
                            </div>
                            {formRenderProps.valueGetter("nationality") &&
                            formRenderProps.valueGetter("nationality").value ===
                              "Other" ? (
                              <div className="col-6">
                                <Field
                                  id={"other_nationality"}
                                  name={"other_nationality"}
                                  label={localizationService.toLanguageString(
                                    "custom.othernationality"
                                  )}
                                  component={RequiredFormInput}
                                  data={Nationalities}
                                  validator={requiredMax50Validator}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <Field
                                id={"gender"}
                                name={"gender"}
                                label={localizationService.toLanguageString(
                                  "custom.gender"
                                )}
                                component={RequiredDropDownList}
                                data={Genders}
                                validator={requiredValidator}
                              />
                            </div>
                          </div>
                        </div>
                      </Tooltip>
                    </fieldset>

                    <Tooltip
                      openDelay={0}
                      anchorElement="target"
                      parentTitle={true}
                      position={"left"}
                    >
                      <div className="float-right">
                        <div title={disabletitle()}>
                          <Button
                            primary={true}
                            type={"submit"}
                            className="mr-2em"
                            disabled={disableFunction()}
                          >
                            {loading
                              ? localizationService.toLanguageString(
                                  "custom.loading"
                                )
                              : localizationService.toLanguageString(
                                  "custom.save"
                                )}
                          </Button>
                        </div>
                      </div>
                    </Tooltip>
                  </FormElement>
                )}
              />
            </TabStripTab>
            <TabStripTab
              title={localizationService.toLanguageString(
                "custom.approvesection"
              )}
            >
              <ApproveStudySubject
                study_subject={props.location.state.data.id}
                section={props.location.state.section.id}
                data={props.location.state.data}
                parentCallBack={ChangeApproveSection}
              />
            </TabStripTab>
            <TabStripTab
              title={localizationService.toLanguageString(
                "custom.notesnattachements"
              )}
            >
              <TabStrip selected={Subselected} onSelect={handleSubSelect}>
                <TabStripTab
                  title={localizationService.toLanguageString("custom.notes")}
                >
                  <GridTelerik data={notes}>
                    <GridToolbar>
                      <Button
                        primary={true}
                        onClick={() => {
                          {
                            EditSubject
                              ? toggleDaddNote()
                              : toggleDPermission();
                          }
                        }}
                      >
                        {localizationService.toLanguageString("custom.new")}
                      </Button>
                    </GridToolbar>

                    <Column
                      field={"name"}
                      title={localizationService.toLanguageString(
                        "custom.name"
                      )}
                      cell={NoteNameTemplate}
                    />
                    <Column
                      field={"date_created"}
                      title={localizationService.toLanguageString(
                        "custom.datecreated"
                      )}
                      cell={DateCreatedTemplate}
                    />
                    <Column
                      title={localizationService.toLanguageString(
                        "custom.actions"
                      )}
                      width="100px"
                      cell={Noteactions}
                    />
                  </GridTelerik>
                </TabStripTab>

                <TabStripTab
                  title={localizationService.toLanguageString(
                    "custom.attachements"
                  )}
                >
                  <GridTelerik data={attachements}>
                    <GridToolbar>
                      <Button
                        primary={true}
                        onClick={() => {
                          {
                            EditSubject
                              ? toggleDaddFile()
                              : toggleDPermission();
                          }
                        }}
                      >
                        {localizationService.toLanguageString("custom.new")}
                      </Button>
                    </GridToolbar>
                    <Column
                      field={"title"}
                      title={localizationService.toLanguageString(
                        "custom.title"
                      )}
                    />

                    <Column
                      field={"date_created"}
                      title={localizationService.toLanguageString(
                        "custom.dateadded"
                      )}
                      cell={DateCreatedTemplate}
                    />

                    <Column
                      title={localizationService.toLanguageString(
                        "custom.actions"
                      )}
                      width="100px"
                      cell={Fileactions}
                    />
                  </GridTelerik>
                </TabStripTab>
              </TabStrip>
            </TabStripTab>
          </TabStrip>
        </div>
      </div>
      <NotificationGroup style={position.topCenter}>
        <Fade>
          {nosave && (
            <Notification
              type={{
                style: "error",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, nosave: false })}
            >
              <span>
                {ErrorNotification}{" "}
                {localizationService.toLanguageString("custom.errornosave")}
              </span>
            </Notification>
          )}
        </Fade>
        <Fade>
          {nomodify && (
            <Notification
              type={{
                style: "warning",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, nomodify: false })}
            >
              <span>
                {localizationService.toLanguageString(
                  "custom.nomodificationchange"
                )}
              </span>
            </Notification>
          )}
        </Fade>
        <Fade>
          {success && (
            <Notification
              type={{
                style: "success",
                icon: true,
              }}
              closable={true}
              onClose={() => setState({ ...state, success: false })}
            >
              <span>
                {localizationService.toLanguageString("custom.datasaved")}
              </span>
            </Notification>
          )}
        </Fade>
      </NotificationGroup>
      {/* MODIFY REASON DIALOG */}
      {VModifyreason && (
        <Dialog
          title={localizationService.toLanguageString(
            "custom.modificationreason"
          )}
          onClose={toggleDModifyreason}
          width={"700px"}
          height={"400px"}
        >
          <div>
            <p style={{ margin: "25px", textAlign: "center" }}>
              {localizationService.toLanguageString(
                "custom.pleasespecifymodifyreason"
              )}
            </p>
            <Form
              initialValues={{
                modification_reason: "",
              }}
              onSubmit={CreateModification}
              render={(formRenderProps) => (
                <FormElement className="">
                  <fieldset className={"k-form-fieldset"}>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          id={"modification_reason"}
                          name={"modification_reason"}
                          label={localizationService.toLanguageString(
                            "custom.reason"
                          )}
                          validator={requiredValidator}
                          component={RequiredFormTextArea}
                        />
                      </div>
                    </div>

                    <div className="row mb-2 mt-2">
                      <div className="col-12">
                        <div className="float-right">
                          <Button
                            primary={true}
                            type={"submit"}
                            className="mr-2em"
                          >
                            {localizationService.toLanguageString(
                              "custom.save"
                            )}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </FormElement>
              )}
            />
          </div>
        </Dialog>
      )}
      {/* PERMISSION DIALOG */}
      {VPermission && (
        <Dialog
          title={localizationService.toLanguageString(
            "custom.permissiondenied"
          )}
          onClose={toggleDPermission}
        >
          <PermissionDenied onClose={toggleDPermission} />
        </Dialog>
      )}
      {VaddNote && (
        <Dialog
          width="700px"
          title={localizationService.toLanguageString("custom.addnote")}
          onClose={toggleDaddNote}
        >
          <AddNote
            onClose={toggleDaddNote}
            section={props.location.state.section.id}
            subject={props.location.state.data.id}
          />
        </Dialog>
      )}
      {VeditNote && (
        <Dialog
          width="700px"
          title={localizationService.toLanguageString("custom.editnote")}
          onClose={toggleDeditNote}
        >
          <AddNote onClose={toggleDeditNote} data={EditNote} />
        </Dialog>
      )}
      {Vdelete && (
        <Dialog
          title={localizationService.toLanguageString("custom.confirm")}
          onClose={toggleDdelete}
        >
          <DeleteObject onClose={toggleDdelete} Name={Name} api={DeleteAPI} />
        </Dialog>
      )}
      {VaddFile && (
        <Dialog
          width="600px"
          title={localizationService.toLanguageString("custom.upload")}
          onClose={toggleDaddFile}
        >
          <AddFile
            onClose={toggleDaddFile}
            section={props.location.state.section.id}
            subject={props.location.state.data.id}
          />
        </Dialog>
      )}
      {VTabStripChange && (
        <Dialog
          title={localizationService.toLanguageString("custom.confirm")}
          onClose={toggleDTabStripChange}
        >
          <TabChange
            selected={selectedTab}
            parentCallBack={TabCallBack}
            onClose={toggleDTabStripChange}
          />
        </Dialog>
      )}
    </TrialMap>
  );
}

export default AddDemography;
